module.exports = {
  "/": {
    "name": "redirect-to-basic"
  },
  "/global-preferences": {
    "name": "redirect-to-global-preferences"
  },
  "/global-integrations": {
    "name": "redirect-to-global-integrations"
  },
  "/basic": {
    "name": "basic",
    "success": {
      "loaded sucessfully": [
        "UP_FRONT_REQUEST_LOADED",
        "LANGUAGE_EDITOR_DATA_LOADED"
      ]
    },
    "error": [
      "LANGUAGE_EDITOR_DATA_ERROR",
      "UP_FRONT_REQUEST_ERROR"
    ]
  },
  "/profile": {
    "name": "profile",
    "success": {
      "loaded sucessfully": [
        "UP_FRONT_REQUEST_LOADED",
        "LANGUAGE_EDITOR_DATA_LOADED"
      ]
    },
    "error": [
      "LANGUAGE_EDITOR_DATA_ERROR",
      "UP_FRONT_REQUEST_ERROR"
    ]
  },
  "/user-preferences/:portalId": {
    "name": "user-preferences-index-redirect"
  },
  "/workflows": {
    "name": "workflows"
  }
};